import isEmpty from '../../app/utils/isEmpty';
import {
    SET_CURRENT_USER,
    SIGNUP_REQUEST,
    SIGNUP_SUCCESS,
    SIGNUP_FAILURE,
    SIGNUP_CONFIRM_EMAIL_FAILURE,
    SIGNUP_CONFIRM_EMAIL_REQUEST,
    SIGNUP_CONFIRM_EMAIL_SUCCESS,
    SIGNIN_REQUEST,
    SIGNIN_FAILURE,
    FORGOT_PASSWORD_REQUEST,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_FAILURE,
    CHECK_FORGOT_PASSWORD_KEY_REQUEST,
    CHECK_FORGOT_PASSWORD_KEY_SUCCESS,
    CHECK_FORGOT_PASSWORD_KEY_FAILURE,
    SET_NEW_PASSWORD_REQUEST,
    SET_NEW_PASSWORD_SUCCESS,
    SET_NEW_PASSWORD_FAILURE,
} from './types';

const initialState = {
    isAuthenticated: false,
    user: {},

    signupLoading: false,
    signupSuccess: null,
    signupErrors: {},

    signupConfirmEmailLoading: false,
    signupConfirmEmailSuccess: false,
    signupConfirmEmailErrors: {},

    signinLoading: false,
    signinErrors: {},

    forgotPasswordLoading: false,
    forgotPasswordSuccess: false,
    forgotPasswordErrors: {},

    checkForgotPasswordKeyLoading: false,
    checkForgotPasswordKeySuccess: false,
    checkForgotPasswordKeyErrors: {},

    setNewPasswordLoading: false,
    setNewPasswordSuccess: false,
    setNewPasswordErrors: {},
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SIGNUP_REQUEST:
            return {
                ...state,
                signupLoading: true,
                signupSuccess: null,
                signupErrors: {},
            };
        case SIGNUP_SUCCESS:
            return {
                ...state,
                signupLoading: false,
                signupSuccess: action.payload,
                signupErrors: {},
            };
        case SIGNUP_FAILURE:
            return {
                ...state,
                signupLoading: false,
                signupSuccess: null,
                signupErrors: action.payload,
            };
        case SIGNIN_REQUEST:
            return {
                ...state,
                signinLoading: true,
                signinErrors: {},
            };
        case SIGNIN_FAILURE:
            return {
                ...state,
                signinLoading: false,
                signinErrors: action.payload,
            };
        case SIGNUP_CONFIRM_EMAIL_REQUEST:
            return {
                ...state,
                signupConfirmEmailLoading: true,
                signupConfirmEmailSuccess: false,
                signupConfirmEmailErrors: {},
            };
        case SIGNUP_CONFIRM_EMAIL_SUCCESS:
            return {
                ...state,
                signupConfirmEmailLoading: false,
                signupConfirmEmailSuccess: true,
                signupConfirmEmailErrors: {},
            };
        case SIGNUP_CONFIRM_EMAIL_FAILURE:
            return {
                ...state,
                signupConfirmEmailLoading: false,
                signupConfirmEmailSuccess: false,
                signupConfirmEmailErrors: action.payload,
            };
        case FORGOT_PASSWORD_REQUEST:
            return {
                ...state,
                forgotPasswordLoading: true,
                forgotPasswordSuccess: false,
                forgotPasswordErrors: {},
            };
        case FORGOT_PASSWORD_SUCCESS:
            return {
                ...state,
                forgotPasswordLoading: false,
                forgotPasswordSuccess: true,
                forgotPasswordErrors: {},
            };
        case FORGOT_PASSWORD_FAILURE:
            return {
                ...state,
                forgotPasswordLoading: false,
                forgotPasswordSuccess: false,
                forgotPasswordErrors: action.payload,
            };
        case CHECK_FORGOT_PASSWORD_KEY_REQUEST:
            return {
                ...state,
                checkForgotPasswordKeyLoading: true,
                checkForgotPasswordKeySuccess: false,
                checkForgotPasswordKeyErrors: {},
            };
        case CHECK_FORGOT_PASSWORD_KEY_SUCCESS:
            return {
                ...state,
                checkForgotPasswordKeyLoading: false,
                checkForgotPasswordKeySuccess: true,
                checkForgotPasswordKeyErrors: {},
            };
        case CHECK_FORGOT_PASSWORD_KEY_FAILURE:
            return {
                ...state,
                checkForgotPasswordKeyLoading: false,
                checkForgotPasswordKeySuccess: false,
                checkForgotPasswordKeyErrors: action.payload,
            };
        case SET_NEW_PASSWORD_REQUEST:
            return {
                ...state,
                setNewPasswordLoading: true,
                setNewPasswordSuccess: false,
                setNewPasswordErrors: {},
            };
        case SET_NEW_PASSWORD_SUCCESS:
            return {
                ...state,
                setNewPasswordLoading: false,
                setNewPasswordSuccess: true,
                setNewPasswordErrors: {},
            };
        case SET_NEW_PASSWORD_FAILURE:
            return {
                ...state,
                setNewPasswordLoading: false,
                setNewPasswordSuccess: false,
                setNewPasswordErrors: action.payload,
            };
        case SET_CURRENT_USER:
            const payload = action.payload;
            const user = (payload.hasOwnProperty('data') && payload.data.hasOwnProperty('user')) ? action.payload.data.user : {};

            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                user: user,
                signinLoading: false,
                signinErrors: {},
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/features/Auth/reducers.js